import React, { useState, useMemo } from 'react'
import { useScrollPosition } from '@n8tb1t/use-scroll-position'
import { Link } from 'gatsby'
import chatIcon from '../../../../img/chatbot.svg'
import { Sidebar } from './NavbarSideStyles'

export default () => {
  const [hideOnScroll, setHideOnScroll] = useState(true)

  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y
      if (isShow !== hideOnScroll) setHideOnScroll(isShow)
    },
    [hideOnScroll],
    false,
    false,
    300
  )

  return useMemo(
    () => (
      <>
        <Sidebar show={hideOnScroll}>
          <div
            role='navigation'
            aria-label='bottom-navigation'
          >
            <Link to='/kontakt'>
              <img src={chatIcon} alt='Logo' style={{ width: '3rem', height: '3rem' }} />
            </Link>
          </div>
        </Sidebar>
      </>
    ),
    [hideOnScroll]
  )
}
